import { Component, Input, OnInit } from '@angular/core';
import { UiCorePipesModule } from '@softline/ui-core';

@Component({
  selector: 'soft-dynamic-draw-value',
  templateUrl: './draw.component.html',
  styleUrls: ['./draw.component.scss'],
  imports: [UiCorePipesModule],
})
export class DrawComponent implements OnInit {
  @Input() value?: any;

  constructor() {}

  ngOnInit(): void {}
}
